import React, { Component } from 'react';
import { Document, Page } from 'react-pdf';
import { Button, Row, Col } from 'antd';
import SEO from '../components/Seo';

export default class Resume extends Component {
  constructor() {
    super();
    this.state = {
      numPages: null,
      pageNumber: 1,
    };
    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.goPrev = this.goPrev.bind(this);
    this.goNext = this.goNext.bind(this);
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages });
  }

  goPrev() {
    this.setState((prev) => ({ pageNumber: Math.max(1, prev.pageNumber - 1) }));
  }

  goNext() {
    this.setState((prev) => ({
      pageNumber: Math.min(prev.numPages || 1, prev.pageNumber + 1),
    }));
  }

  render() {
    const { pageNumber, numPages } = this.state;
    return (
      <div>
        <SEO
          title="Resume"
          description="Resume of Muhammad Muneeb ur Rehman - robotics engineer specialising in digital twins,
          Sim2Real transfer, UAV systems and reinforcement learning."
          path="resume"
        />
        <Document
          file="../resume.pdf"
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} />
        </Document>
        <Row justify="center" align="middle" gutter={16} style={{ background: 'lightslategray', padding: '10px 0' }}>
          <Col>
            <Button onClick={this.goPrev} disabled={pageNumber <= 1}>
              Previous
            </Button>
          </Col>
          <Col>
            <p style={{ margin: 0, color: 'white' }}>
              {numPages !== null && `Page ${pageNumber} of ${numPages}`}
            </p>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={this.goNext}
              disabled={numPages !== null && pageNumber >= numPages}
            >
              Next
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
